import { render, staticRenderFns } from "./DocTypeNew.vue?vue&type=template&id=65409798&"
import script from "./DocTypeNew.vue?vue&type=script&lang=js&"
export * from "./DocTypeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports